// import React from 'react';
// import { useFormik } from 'formik';
// import * as Yup from 'yup';
// import {
//   Box,
//   Button,
//   TextField,
//   Typography,
//   Grid,
// } from '@mui/material';
// import { useDispatch } from 'react-redux';
// import { useAppDispatch } from '../../../Redux Toolkit/Store';
// import { createOrder } from '../../../Redux Toolkit/Customer/OrderSlice';
// import { Address } from '../../../types/userTypes';

// // Validation schema
// const ContactSchema = Yup.object().shape({
//   name: Yup.string().required('Required'),
//   mobile: Yup.string()
//     .matches(/^[6-9]\d{9}$/, 'Invalid mobile number')
//     .required('Required'),
//   pinCode: Yup.string()
//     .matches(/^\d{6}$/, 'Invalid pincode')
//     .required('Required'),
//   address: Yup.string().required('Required'),
//   locality: Yup.string().required('Required'),
//   city: Yup.string().required('Required'),
//   state: Yup.string().required('Required'),
// });

// interface AddressFormProp {
//   handleClose: () => void;
//   paymentGateway:string
// }

// const AddressForm:React.FC<AddressFormProp> = ({handleClose,paymentGateway}) => {
//   const dispatch=useAppDispatch()
//   const formik = useFormik({
//     initialValues: {
//       name: '',
//       mobile: '',
//       pinCode: '',
//       address: '',
//       locality: '',
//       city: '',
//       state: '',
//     },
//     validationSchema: ContactSchema,
//     onSubmit: (values) => {
//       console.log("form submited", values);
//       handleCreateOrder(values as Address);
//       handleClose();
//     },
//   });

//   const handleCreateOrder=(address:Address)=>{
//     dispatch(createOrder({address,jwt:localStorage.getItem('jwt')|| "",paymentGateway}))
//   }

//   return (
//     <Box sx={{ maxWidth: 600, mx: 'auto'}}>
//       <p className='text-xl font-bold text-center pb-5'>
//         Contact Details
//       </p>
//       <form onSubmit={formik.handleSubmit}>
//         <Grid container spacing={3}>
//           <Grid item xs={12}>
//             <TextField
//               fullWidth
//               name="name"
//               label="Name"
//               value={formik.values.name}
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               error={formik.touched.name && Boolean(formik.errors.name)}
//               helperText={formik.touched.name && formik.errors.name}
//             />
//           </Grid>
//           <Grid item xs={6}>
//             <TextField
//               fullWidth
//               name="mobile"
//               label="Mobile"
//               value={formik.values.mobile}
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               error={formik.touched.mobile && Boolean(formik.errors.mobile)}
//               helperText={formik.touched.mobile && formik.errors.mobile}
//             />
//           </Grid>
//           <Grid item xs={6}>
//             <TextField
//               fullWidth
//               name="pinCode"
//               label="Pin Code"
//               value={formik.values.pinCode}
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               error={formik.touched.pinCode && Boolean(formik.errors.pinCode)}
//               helperText={formik.touched.pinCode && formik.errors.pinCode}
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <TextField
//               fullWidth
//               name="address"
//               label="Address (House No, Building, Street)"
//               value={formik.values.address}
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               error={formik.touched.address && Boolean(formik.errors.address)}
//               helperText={formik.touched.address && formik.errors.address}
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <TextField
//               fullWidth
//               name="locality"
//               label="Locality/Town"
//               value={formik.values.locality}
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               error={formik.touched.locality && Boolean(formik.errors.locality)}
//               helperText={formik.touched.locality && formik.errors.locality}
//             />
//           </Grid>
//           <Grid item xs={6}>
//             <TextField
//               fullWidth
//               name="city"
//               label="City"
//               value={formik.values.city}
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               error={formik.touched.city && Boolean(formik.errors.city)}
//               helperText={formik.touched.city && formik.errors.city}
//             />
//           </Grid>
//           <Grid item xs={6}>
//             <TextField
//               fullWidth
//               name="state"
//               label="State"
//               value={formik.values.state}
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               error={formik.touched.state && Boolean(formik.errors.state)}
//               helperText={formik.touched.state && formik.errors.state}
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <Button sx={{py:"14px"}} type="submit" variant="contained" color="primary" fullWidth>
//               Add Address
//             </Button>
//           </Grid>
//         </Grid>
//       </form>
//     </Box>
//   );
// };

// export default AddressForm;


// import React, { useEffect, useState } from 'react';
// import { useFormik } from 'formik';
// import * as Yup from 'yup';
// import {
//   Box,
//   Button,
//   TextField,
//   Typography,
//   Grid,
// } from '@mui/material';
// import { useDispatch } from 'react-redux';
// import { useAppDispatch } from '../../../Redux Toolkit/Store';
// import { createOrder } from '../../../Redux Toolkit/Customer/OrderSlice';
// import { Address } from '../../../types/userTypes';

// // Validation schema
// const ContactSchema = Yup.object().shape({
//   name: Yup.string().required('Required'),
//   mobile: Yup.string()
//     .matches(/^[6-9]\d{9}$/, 'Invalid mobile number')
//     .required('Required'),
//   pinCode: Yup.string()
//     .matches(/^\d{6}$/, 'Invalid pincode')
//     .required('Required'),
//   address: Yup.string().required('Required'),
//   locality: Yup.string().required('Required'),
//   city: Yup.string().required('Required'),
//   state: Yup.string().required('Required'),
// });

// interface AddressFormProp {
//   handleClose: () => void;
//   paymentGateway: string;
// }

// const AddressForm: React.FC<AddressFormProp> = ({ handleClose, paymentGateway }) => {
//   const dispatch = useAppDispatch();
//   const [autoFilled, setAutoFilled] = useState(false);

//   const formik = useFormik({
//     initialValues: {
//       name: '',
//       mobile: '',
//       pinCode: '',
//       address: '',
//       locality: '',
//       city: '',
//       state: '',
//     },
//     validationSchema: ContactSchema,
//     onSubmit: (values) => {
//       console.log("form submited", values);
//       handleCreateOrder(values as Address);
//       handleClose();
//     },
//   });

//   const handleCreateOrder = (address: Address) => {
//     dispatch(createOrder({ address, jwt: localStorage.getItem('jwt') || "", paymentGateway }))
//   }

//   // ✅ Auto-fill city and state based on pincode
//   useEffect(() => {
//     const fetchLocation = async () => {
//       const pinCode = formik.values.pinCode;
//       if (pinCode.length === 6) {
//         try {
//           const res = await fetch(`https://api.postalpincode.in/pincode/${pinCode}`);
//           const data = await res.json();
//           if (data[0].Status === 'Success') {
//             const postOffice = data[0].PostOffice[0];
//             formik.setFieldValue('city', postOffice.District);
//             formik.setFieldValue('state', postOffice.State);
//             setAutoFilled(true);
//           } else {
//             setAutoFilled(false);
//           }
//         } catch (error) {
//           console.error("Error fetching city/state from pincode:", error);
//           setAutoFilled(false);
//         }
//       } else {
//         setAutoFilled(false);
//       }
//     };

//     fetchLocation();
//   }, [formik.values.pinCode]);

//   return (
//     <Box sx={{ maxWidth: 600, mx: 'auto' }}>
//       <p className='text-xl font-bold text-center pb-5'>
//         Contact Details
//       </p>
//       <form onSubmit={formik.handleSubmit}>
//         <Grid container spacing={3}>
//           <Grid item xs={12}>
//             <TextField
//               fullWidth
//               name="name"
//               label="Name"
//               value={formik.values.name}
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               error={formik.touched.name && Boolean(formik.errors.name)}
//               helperText={formik.touched.name && formik.errors.name}
//             />
//           </Grid>
//           <Grid item xs={6}>
//             <TextField
//               fullWidth
//               name="mobile"
//               label="Mobile"
//               value={formik.values.mobile}
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               error={formik.touched.mobile && Boolean(formik.errors.mobile)}
//               helperText={formik.touched.mobile && formik.errors.mobile}
//             />
//           </Grid>
//           <Grid item xs={6}>
//             <TextField
//               fullWidth
//               name="pinCode"
//               label="Pin Code"
//               value={formik.values.pinCode}
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               error={formik.touched.pinCode && Boolean(formik.errors.pinCode)}
//               helperText={formik.touched.pinCode && formik.errors.pinCode}
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <TextField
//               fullWidth
//               name="address"
//               label="Address (House No, Building, Street)"
//               value={formik.values.address}
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               error={formik.touched.address && Boolean(formik.errors.address)}
//               helperText={formik.touched.address && formik.errors.address}
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <TextField
//               fullWidth
//               name="locality"
//               label="Locality/Town"
//               value={formik.values.locality}
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               error={formik.touched.locality && Boolean(formik.errors.locality)}
//               helperText={formik.touched.locality && formik.errors.locality}
//             />
//           </Grid>
//           <Grid item xs={6}>
//             <TextField
//               fullWidth
//               name="city"
//               label="City"
//               value={formik.values.city}
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               error={formik.touched.city && Boolean(formik.errors.city)}
//               helperText={formik.touched.city && formik.errors.city}
//               disabled={autoFilled}
//             />
//           </Grid>
//           <Grid item xs={6}>
//             <TextField
//               fullWidth
//               name="state"
//               label="State"
//               value={formik.values.state}
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               error={formik.touched.state && Boolean(formik.errors.state)}
//               helperText={formik.touched.state && formik.errors.state}
//               disabled={autoFilled}
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <Button sx={{ py: "14px" }} type="submit" variant="contained" color="primary" fullWidth>
//               Add Address
//             </Button>
//           </Grid>
//         </Grid>
//       </form>
//     </Box>
//   );
// };

// export default AddressForm;


// import React, { useEffect, useState } from "react";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import { Box, Button, TextField, Grid } from "@mui/material";
// import { useAppDispatch } from "../../../Redux Toolkit/Store";
// import { createOrder } from "../../../Redux Toolkit/Customer/OrderSlice";
// import { Address } from "../../../types/userTypes";

// const ContactSchema = Yup.object().shape({
//   name: Yup.string().required("Required"),
//   mobile: Yup.string()
//     .matches(/^[6-9]\d{9}$/, "Invalid mobile number")
//     .required("Required"),
//   pinCode: Yup.string()
//     .matches(/^\d{6}$/, "Invalid pincode")
//     .required("Required"),
//   address: Yup.string().required("Required"),
//   locality: Yup.string().required("Required"),
//   city: Yup.string().required("Required"),
//   state: Yup.string().required("Required"),
// });

// interface AddressFormProp {
//   handleClose: () => void;
//   paymentGateway?: string;
//   mode?: "checkout" | "profile";
//   onAddressSubmit?: (address: Address) => void;
// }

// const AddressForm: React.FC<AddressFormProp> = ({
//   handleClose,
//   paymentGateway = "",
//   mode = "checkout",
//   onAddressSubmit,
// }) => {
//   const dispatch = useAppDispatch();
//   const [autoFilled, setAutoFilled] = useState(false);

//   const handleCreateOrder = (address: Address) => {
//     dispatch(
//       createOrder({
//         address,
//         jwt: localStorage.getItem("jwt") || "",
//         paymentGateway,
//       })
//     );
//   };

//   const formik = useFormik({
//     initialValues: {
//       name: "",
//       mobile: "",
//       pinCode: "",
//       address: "",
//       locality: "",
//       city: "",
//       state: "",
//     },
//     validationSchema: ContactSchema,
//     // onSubmit: (values) => {
//     //   const address = values as Address;

//     //   if (mode === "profile") {
//     //     onAddressSubmit?.(address);
//     //   } else {
//     //     handleCreateOrder(address);
//     //   }

//     //   handleClose();
//     // },
//     onSubmit: (values) => {
//   const address = values as Address;

//   handleCreateOrder(address);

//   onAddressSubmit?.(address);

//   handleClose();
// },
//   });

//   useEffect(() => {
//     const fetchLocation = async () => {
//       const pinCode = formik.values.pinCode;

//       if (pinCode.length === 6) {
//         try {
//           const res = await fetch(
//             `https://api.postalpincode.in/pincode/${pinCode}`
//           );
//           const data = await res.json();

//           if (data[0].Status === "Success") {
//             const postOffice = data[0].PostOffice[0];

//             formik.setFieldValue("city", postOffice.District);
//             formik.setFieldValue("state", postOffice.State);
//             setAutoFilled(true);
//           } else {
//             setAutoFilled(false);
//           }
//         } catch (error) {
//           console.error("Error fetching city/state from pincode:", error);
//           setAutoFilled(false);
//         }
//       } else {
//         setAutoFilled(false);
//       }
//     };

//     fetchLocation();
//   }, [formik.values.pinCode]);

//   return (
//     <Box sx={{ maxWidth: 600, mx: "auto" }}>
//       <p className="text-xl font-bold text-center pb-5">
//         {mode === "profile" ? "Add New Address" : "Contact Details"}
//       </p>

//       <form onSubmit={formik.handleSubmit}>
//         <Grid container spacing={3}>
//           <Grid item xs={12}>
//             <TextField
//               fullWidth
//               name="name"
//               label="Name"
//               value={formik.values.name}
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               error={formik.touched.name && Boolean(formik.errors.name)}
//               helperText={formik.touched.name && formik.errors.name}
//             />
//           </Grid>

//           <Grid item xs={6}>
//             <TextField
//               fullWidth
//               name="mobile"
//               label="Mobile"
//               value={formik.values.mobile}
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               error={formik.touched.mobile && Boolean(formik.errors.mobile)}
//               helperText={formik.touched.mobile && formik.errors.mobile}
//             />
//           </Grid>

//           <Grid item xs={6}>
//             <TextField
//               fullWidth
//               name="pinCode"
//               label="Pin Code"
//               value={formik.values.pinCode}
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               error={formik.touched.pinCode && Boolean(formik.errors.pinCode)}
//               helperText={formik.touched.pinCode && formik.errors.pinCode}
//             />
//           </Grid>

//           <Grid item xs={12}>
//             <TextField
//               fullWidth
//               name="address"
//               label="Address (House No, Building, Street)"
//               value={formik.values.address}
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               error={formik.touched.address && Boolean(formik.errors.address)}
//               helperText={formik.touched.address && formik.errors.address}
//             />
//           </Grid>

//           <Grid item xs={12}>
//             <TextField
//               fullWidth
//               name="locality"
//               label="Locality/Town"
//               value={formik.values.locality}
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               error={
//                 formik.touched.locality && Boolean(formik.errors.locality)
//               }
//               helperText={formik.touched.locality && formik.errors.locality}
//             />
//           </Grid>

//           <Grid item xs={6}>
//             <TextField
//               fullWidth
//               name="city"
//               label="City"
//               value={formik.values.city}
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               error={formik.touched.city && Boolean(formik.errors.city)}
//               helperText={formik.touched.city && formik.errors.city}
//               disabled={autoFilled}
//             />
//           </Grid>

//           <Grid item xs={6}>
//             <TextField
//               fullWidth
//               name="state"
//               label="State"
//               value={formik.values.state}
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               error={formik.touched.state && Boolean(formik.errors.state)}
//               helperText={formik.touched.state && formik.errors.state}
//               disabled={autoFilled}
//             />
//           </Grid>

//           <Grid item xs={12}>
//             <Button
//               sx={{ py: "14px" }}
//               type="submit"
//               variant="contained"
//               color="primary"
//               fullWidth
//             >
//               {mode === "profile" ? "Save Address" : "Add Address"}
//             </Button>
//           </Grid>
//         </Grid>
//       </form>
//     </Box>
//   );
// };

// export default AddressForm;


// import React, { useEffect, useState } from "react";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import { Box } from "@mui/material";
// import {
//   ArrowLeft,
//   User,
//   Phone,
//   Mail,
//   Home,
//   Briefcase,
//   MoreHorizontal,
//   MapPin,
//   Flag,
//   Building2,
//   Map,
//   Globe2,
//   StickyNote,
// } from "lucide-react";
// import { useAppDispatch } from "../../../Redux Toolkit/Store";
// import { createOrder } from "../../../Redux Toolkit/Customer/OrderSlice";
// import { Address } from "../../../types/userTypes";

// const ContactSchema = Yup.object().shape({
//   name: Yup.string().required("Required"),
//   mobile: Yup.string()
//     .matches(/^[6-9]\d{9}$/, "Invalid mobile number")
//     .required("Required"),
//   email: Yup.string().email("Invalid email"),
//   pinCode: Yup.string()
//     .matches(/^\d{6}$/, "Invalid pincode")
//     .required("Required"),
//   address: Yup.string().required("Required"),
//   locality: Yup.string().required("Required"),
//   city: Yup.string().required("Required"),
//   state: Yup.string().required("Required"),
// });

// interface AddressFormProp {
//   handleClose: () => void;
//   paymentGateway?: string;
//   mode?: "checkout" | "profile";
//   onAddressSubmit?: (address: Address) => void;
// }

// const inputBase =
//   "w-full h-[54px] rounded-xl border border-gray-300 bg-white px-4 pl-12 text-sm outline-none transition focus:border-pink-500 focus:ring-1 focus:ring-pink-500";

// const labelBase =
//   "absolute -top-2 left-4 bg-white px-2 text-xs font-medium text-gray-700";

// const FieldWrapper = ({
//   label,
//   icon,
//   children,
// }: {
//   label: string;
//   icon: React.ReactNode;
//   children: React.ReactNode;
// }) => (
//   <div className="relative">
//     <label className={labelBase}>{label}</label>
//     <div className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-700">
//       {icon}
//     </div>
//     {children}
//   </div>
// );

// const AddressForm: React.FC<AddressFormProp> = ({
//   handleClose,
//   paymentGateway = "",
//   mode = "checkout",
//   onAddressSubmit,
// }) => {
//   const dispatch = useAppDispatch();
//   const [autoFilled, setAutoFilled] = useState(false);
//   const [addressType, setAddressType] = useState<"home" | "work" | "other">(
//     "home"
//   );
//   const [isDefault, setIsDefault] = useState(true);

//   const handleCreateOrder = (address: Address) => {
//     dispatch(
//       createOrder({
//         address,
//         jwt: localStorage.getItem("jwt") || "",
//         paymentGateway,
//       })
//     );
//   };

//   const formik = useFormik({
//     initialValues: {
//       name: "",
//       mobile: "",
//       email: "",
//       pinCode: "",
//       address: "",
//       locality: "",
//       landmark: "",
//       city: "",
//       state: "",
//       country: "India",
//       notes: "",
//     },
//     validationSchema: ContactSchema,
//     onSubmit: (values) => {
//       const address = {
//         name: values.name,
//         mobile: values.mobile,
//         pinCode: values.pinCode,
//         address: values.address,
//         locality: values.locality,
//         city: values.city,
//         state: values.state,
//       } as Address;

//       if (mode === "checkout") {
//         handleCreateOrder(address);
//       }

//       onAddressSubmit?.(address);
//       handleClose();
//     },
//   });

//   useEffect(() => {
//     const fetchLocation = async () => {
//       const pinCode = formik.values.pinCode;

//       if (pinCode.length === 6) {
//         try {
//           const res = await fetch(
//             `https://api.postalpincode.in/pincode/${pinCode}`
//           );
//           const data = await res.json();

//           if (data[0].Status === "Success") {
//             const postOffice = data[0].PostOffice[0];
//             formik.setFieldValue("city", postOffice.District);
//             formik.setFieldValue("state", postOffice.State);
//             setAutoFilled(true);
//           } else {
//             setAutoFilled(false);
//           }
//         } catch (error) {
//           console.error("Error fetching city/state from pincode:", error);
//           setAutoFilled(false);
//         }
//       } else {
//         setAutoFilled(false);
//       }
//     };

//     fetchLocation();
//   }, [formik.values.pinCode]);

//   const errorText = (field: keyof typeof formik.values) =>
//     formik.touched[field] && formik.errors[field] ? (
//       <p className="mt-1 text-xs text-red-500">{formik.errors[field]}</p>
//     ) : null;

//   return (
//     <Box sx={{ width: "100%" }}>
//       <div className="mx-auto w-full max-w-[1180px] bg-white px-5 py-0 md:px-6 md:py-4 lg:px-0">
//         <div className="-mx-5 mb-6 flex h-[76px] items-center justify-center border-b border-gray-200 px-5 md:mx-0 md:mb-5 md:h-auto md:justify-start md:border-b-0 md:px-0">
//           <button
//             type="button"
//             onClick={handleClose}
//             className="absolute left-5 md:static md:mr-3"
//           >
//             <ArrowLeft size={24} />
//           </button>

//           <div className="text-center md:text-left">
//             <h1 className="text-xl font-bold md:text-2xl">Add New Address</h1>
//             <p className="hidden text-sm text-gray-500 md:block">
//               Please fill in the details carefully to add a new address.
//             </p>
//           </div>
//         </div>

//         <form
//           onSubmit={formik.handleSubmit}
//           className="overflow-hidden rounded-none border-gray-200 md:rounded-xl md:border"
//         >
//           <div className="grid grid-cols-1 md:grid-cols-[1.45fr_0.95fr]">
//             <section className="border-b border-gray-200 pb-6 md:border-b-0 md:border-r md:p-6">
//               <div className="mb-5 flex items-center gap-3">
//                 <span className="hidden rounded-full bg-pink-50 p-2 text-pink-600 md:inline-flex">
//                   <User size={18} />
//                 </span>
//                 <h2 className="text-lg font-bold">Contact Details</h2>
//               </div>

//               <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
//                 <div>
//                   <FieldWrapper label="Full Name *" icon={<User size={20} />}>
//                     <input
//                       className={inputBase}
//                       name="name"
//                       placeholder="Enter full name"
//                       value={formik.values.name}
//                       onChange={formik.handleChange}
//                       onBlur={formik.handleBlur}
//                     />
//                   </FieldWrapper>
//                   {errorText("name")}
//                 </div>

//                 <div>
//                   <FieldWrapper
//                     label="Mobile Number *"
//                     icon={<Phone size={20} />}
//                   >
//                     <input
//                       className={inputBase}
//                       name="mobile"
//                       placeholder="Enter mobile number"
//                       value={formik.values.mobile}
//                       onChange={formik.handleChange}
//                       onBlur={formik.handleBlur}
//                     />
//                   </FieldWrapper>
//                   {errorText("mobile")}
//                 </div>

//                 <div className="sm:col-span-2">
//                   <FieldWrapper
//                     label="Email (Optional)"
//                     icon={<Mail size={20} />}
//                   >
//                     <input
//                       className={inputBase}
//                       name="email"
//                       placeholder="Enter email address"
//                       value={formik.values.email}
//                       onChange={formik.handleChange}
//                       onBlur={formik.handleBlur}
//                     />
//                   </FieldWrapper>
//                   {errorText("email")}
//                 </div>
//               </div>
//             </section>

//             <section className="py-6 md:border-b-0 md:p-6">
//               <div className="mb-5 flex items-center gap-3">
//                 <span className="hidden rounded-full bg-pink-50 p-2 text-pink-600 md:inline-flex">
//                   <Home size={18} />
//                 </span>
//                 <h2 className="text-lg font-bold">Address Type *</h2>
//               </div>

//               <div className="rounded-xl border border-gray-300 px-4 py-5">
//                 <label className="-mt-8 mb-4 inline-block bg-white px-2 text-xs font-medium text-gray-700">
//                   Address Type *
//                 </label>
//                 <div className="grid grid-cols-3 gap-3 md:grid-cols-1 md:gap-4"></div>
//                 {[
//                   { key: "home", label: "Home", icon: <Home size={20} /> },
//                   { key: "work", label: "Work", icon: <Briefcase size={20} /> },
//                   {
//                     key: "other",
//                     label: "Other",
//                     icon: <MoreHorizontal size={20} />,
//                   },
//                 ].map((item) => (
//                   <button
//                     key={item.key}
//                     type="button"
//                     onClick={() => setAddressType(item.key as any)}
//                     className="flex items-center gap-3 text-left text-sm font-medium"
//                   >
//                     <span
//                       className={`h-5 w-5 rounded-full border ${addressType === item.key
//                         ? "border-pink-600 ring-4 ring-pink-100"
//                         : "border-gray-400"
//                         }`}
//                     />
//                     {item.icon}
//                     <span>{item.label}</span>
//                   </button>
//                 ))}
//               </div>
//             </section>
//           </div>

//           <section className="border-b border-gray-200 py-6 md:p-6">
//             <div className="mb-5 flex items-center gap-3">
//               <span className="hidden rounded-full bg-pink-50 p-2 text-pink-600 md:inline-flex">
//                 <MapPin size={18} />
//               </span>
//               <h2 className="text-lg font-bold">Address Details</h2>
//             </div>

//             <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
//               <div>
//                 <FieldWrapper
//                   label="Flat, House No., Building Name *"
//                   icon={<Home size={20} />}
//                 >
//                   <input
//                     className={inputBase}
//                     name="address"
//                     placeholder="E.g. 21, Lake View Apartment"
//                     value={formik.values.address}
//                     onChange={formik.handleChange}
//                     onBlur={formik.handleBlur}
//                   />
//                 </FieldWrapper>
//                 {errorText("address")}
//               </div>

//               <div>
//                 <FieldWrapper
//                   label="Area, Street, Sector, Village *"
//                   icon={<MapPin size={20} />}
//                 >
//                   <input
//                     className={inputBase}
//                     name="locality"
//                     placeholder="E.g. 5th Cross, Koramangala"
//                     value={formik.values.locality}
//                     onChange={formik.handleChange}
//                     onBlur={formik.handleBlur}
//                   />
//                 </FieldWrapper>
//                 {errorText("locality")}
//               </div>

//               <div className="md:col-span-2">
//                 <FieldWrapper
//                   label="Landmark (Optional)"
//                   icon={<Flag size={20} />}
//                 >
//                   <input
//                     className={inputBase}
//                     name="landmark"
//                     placeholder="E.g. Near Forum Mall"
//                     value={formik.values.landmark}
//                     onChange={formik.handleChange}
//                   />
//                 </FieldWrapper>
//               </div>

//               <div>
//                 <FieldWrapper
//                   label="City / Town *"
//                   icon={<Building2 size={20} />}
//                 >
//                   <input
//                     className={inputBase}
//                     name="city"
//                     placeholder="Select city"
//                     value={formik.values.city}
//                     onChange={formik.handleChange}
//                     onBlur={formik.handleBlur}
//                     disabled={autoFilled}
//                   />
//                 </FieldWrapper>
//                 {errorText("city")}
//               </div>

//               <div>
//                 <FieldWrapper label="State *" icon={<Map size={20} />}>
//                   <input
//                     className={inputBase}
//                     name="state"
//                     placeholder="Select state"
//                     value={formik.values.state}
//                     onChange={formik.handleChange}
//                     onBlur={formik.handleBlur}
//                     disabled={autoFilled}
//                   />
//                 </FieldWrapper>
//                 {errorText("state")}
//               </div>

//               <div>
//                 <FieldWrapper label="Pincode *" icon={<Mail size={20} />}>
//                   <input
//                     className={inputBase}
//                     name="pinCode"
//                     placeholder="Enter pincode"
//                     value={formik.values.pinCode}
//                     onChange={formik.handleChange}
//                     onBlur={formik.handleBlur}
//                   />
//                 </FieldWrapper>
//                 {errorText("pinCode")}
//               </div>

//               <FieldWrapper label="Country *" icon={<Globe2 size={20} />}>
//                 <input
//                   className={inputBase}
//                   name="country"
//                   value={formik.values.country}
//                   disabled
//                 />
//               </FieldWrapper>
//             </div>
//           </section>

//           <section className="py-6 md:p-6">
//             <div className="mb-5 flex items-center gap-3">
//               <span className="hidden rounded-full bg-pink-50 p-2 text-pink-600 md:inline-flex">
//                 <StickyNote size={18} />
//               </span>
//               <h2 className="text-lg font-bold">Additional Information</h2>
//             </div>

//             <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
//               <div className="relative">
//                 <label className={labelBase}>Address Notes (Optional)</label>
//                 <textarea
//                   name="notes"
//                   maxLength={100}
//                   placeholder="E.g. Ring the bell, Leave with security, etc."
//                   value={formik.values.notes}
//                   onChange={formik.handleChange}
//                   className="h-[88px] w-full resize-none rounded-xl border border-gray-300 px-4 py-4 text-sm outline-none focus:border-pink-500 focus:ring-1 focus:ring-pink-500"
//                 />
//                 <span className="absolute bottom-3 right-4 text-xs text-gray-500">
//                   {formik.values.notes.length}/100
//                 </span>
//               </div>

//               <div className="flex items-center justify-between rounded-xl border border-gray-300 p-4">
//                 <div>
//                   <p className="font-semibold">Set as Default Address</p>
//                   <p className="text-sm text-gray-500">
//                     This address will be used for all future orders
//                   </p>
//                 </div>

//                 <button
//                   type="button"
//                   onClick={() => setIsDefault(!isDefault)}
//                   className={`relative h-8 w-14 rounded-full transition ${isDefault ? "bg-pink-600" : "bg-gray-300"
//                     }`}
//                 >
//                   <span
//                     className={`absolute top-1 h-6 w-6 rounded-full bg-white transition ${isDefault ? "right-1" : "left-1"
//                       }`}
//                   />
//                 </button>
//               </div>
//             </div>

//             <div className="mt-6 flex flex-col gap-3 md:flex-row-reverse md:justify-start">
//               <button
//                 type="button"
//                 onClick={handleClose}
//                 className="h-[52px] rounded-xl border border-pink-600 px-12 font-semibold text-pink-600 md:min-w-[170px]"
//               >
//                 Cancel
//               </button>

//               <button
//                 type="submit"
//                 className="h-[52px] rounded-xl bg-pink-600 px-12 font-semibold text-white shadow-sm hover:bg-pink-700 md:min-w-[170px]"
//               >
//                 Save Address
//               </button>
//             </div>
//           </section>
//         </form>
//       </div>
//     </Box>
//   );
// };

// export default AddressForm;



// import React, { useEffect, useState } from "react";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import { Box } from "@mui/material";
// import {
//   ArrowLeft,
//   User,
//   Phone,
//   Mail,
//   Home,
//   Briefcase,
//   MoreHorizontal,
//   MapPin,
//   Flag,
//   Building2,
//   Map,
//   Globe2,
// } from "lucide-react";
// import { useAppDispatch } from "../../../Redux Toolkit/Store";
// import { createOrder } from "../../../Redux Toolkit/Customer/OrderSlice";
// import { Address } from "../../../types/userTypes";

// const ContactSchema = Yup.object().shape({
//   name: Yup.string().required("Required"),
//   mobile: Yup.string()
//     .matches(/^[6-9]\d{9}$/, "Invalid mobile number")
//     .required("Required"),
//   email: Yup.string().email("Invalid email"),
//   pinCode: Yup.string()
//     .matches(/^\d{6}$/, "Invalid pincode")
//     .required("Required"),
//   address: Yup.string().required("Required"),
//   locality: Yup.string().required("Required"),
//   city: Yup.string().required("Required"),
//   state: Yup.string().required("Required"),
// });

// interface AddressFormProp {
//   handleClose: () => void;
//   paymentGateway?: string;
//   mode?: "checkout" | "profile";
//   onAddressSubmit?: (address: Address) => void;
// }

// const inputBase =
//   "w-full h-[48px] rounded-xl border border-gray-300 bg-white px-3 pl-10 text-sm outline-none transition focus:border-primary-color focus:ring-1 focus:ring-primary-color";

// const labelBase =
//   "absolute -top-2 left-3 z-10 bg-white px-1.5 text-[11px] font-medium text-gray-700";

// const FieldWrapper = ({
//   label,
//   icon,
//   children,
// }: {
//   label: string;
//   icon: React.ReactNode;
//   children: React.ReactNode;
// }) => (
//   <div className="relative">
//     <label className={labelBase}>{label}</label>

//     <div className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-600">
//       {icon}
//     </div>

//     {children}
//   </div>
// );

// const AddressForm: React.FC<AddressFormProp> = ({
//   handleClose,
//   paymentGateway = "",
//   mode = "checkout",
//   onAddressSubmit,
// }) => {
//   const dispatch = useAppDispatch();

//   const [autoFilled, setAutoFilled] = useState(false);

//   const [addressType, setAddressType] = useState<
//     "home" | "work" | "other"
//   >("home");

//   const [isDefault, setIsDefault] = useState(true);

//   const handleCreateOrder = (address: Address) => {
//     dispatch(
//       createOrder({
//         address,
//         jwt: localStorage.getItem("jwt") || "",
//         paymentGateway,
//       })
//     );
//   };

//   const formik = useFormik({
//     initialValues: {
//       name: "",
//       mobile: "",
//       email: "",
//       pinCode: "",
//       address: "",
//       locality: "",
//       landmark: "",
//       city: "",
//       state: "",
//       country: "India",
//     },

//     validationSchema: ContactSchema,

//     onSubmit: (values) => {
//       const address = {
//         name: values.name,
//         mobile: values.mobile,
//         pinCode: values.pinCode,
//         address: values.address,
//         locality: values.locality,
//         city: values.city,
//         state: values.state,
//       } as Address;

//       if (mode === "checkout") {
//         handleCreateOrder(address);
//       }

//       onAddressSubmit?.(address);

//       handleClose();
//     },
//   });

//   useEffect(() => {
//     const fetchLocation = async () => {
//       const pinCode = formik.values.pinCode;

//       if (pinCode.length === 6) {
//         try {
//           const res = await fetch(
//             `https://api.postalpincode.in/pincode/${pinCode}`
//           );

//           const data = await res.json();

//           if (data[0].Status === "Success") {
//             const postOffice = data[0].PostOffice[0];

//             formik.setFieldValue("city", postOffice.District);

//             formik.setFieldValue("state", postOffice.State);

//             setAutoFilled(true);
//           } else {
//             setAutoFilled(false);
//           }
//         } catch (error) {
//           console.error("Error fetching city/state:", error);

//           setAutoFilled(false);
//         }
//       } else {
//         setAutoFilled(false);
//       }
//     };

//     fetchLocation();
//   }, [formik.values.pinCode]);

//   const errorText = (field: keyof typeof formik.values) =>
//     formik.touched[field] && formik.errors[field] ? (
//       <p className="mt-1 text-[10px] text-red-500">
//         {formik.errors[field]}
//       </p>
//     ) : null;

//   return (
//    <Box sx={{ width: "100%", outline: "none", overflow: "hidden" }}>
//       <div className="mx-auto mt-5 flex h-[86vh] w-full max-w-[430px] flex-col overflow-hidden rounded-3xl bg-white shadow-2xl md:mt-6 md:max-w-[620px]">
//         {/* Header */}
//         <div className="relative flex h-[64px] shrink-0 items-center justify-center border-b border-gray-200 px-4">
//           <button
//             type="button"
//             onClick={handleClose}
//             className="absolute left-4 text-black"
//           >
//             <ArrowLeft size={24} />
//           </button>

//           <h1 className="text-xl font-bold text-black">
//             Add New Address
//           </h1>
//         </div>

//         {/* Form */}
//         <form
//           onSubmit={formik.handleSubmit}
//           className="flex min-h-0 flex-1 flex-col"
//         >
//           <div className="min-h-0 flex-1 overflow-y-auto px-4 py-4">
//             {/* Contact Details */}
//             <section>
//               <h2 className="mb-4 text-[22px] font-bold text-black">
//                 Contact Details
//               </h2>

//               <div className="grid grid-cols-2 gap-3">
//                 {/* Name */}
//                 <div>
//                   <FieldWrapper
//                     label="Full Name *"
//                     icon={<User size={18} />}
//                   >
//                     <input
//                       className={inputBase}
//                       name="name"
//                       placeholder="Enter full name"
//                       value={formik.values.name}
//                       onChange={formik.handleChange}
//                       onBlur={formik.handleBlur}
//                     />
//                   </FieldWrapper>

//                   {errorText("name")}
//                 </div>

//                 {/* Mobile */}
//                 <div>
//                   <FieldWrapper
//                     label="Mobile Number *"
//                     icon={<Phone size={18} />}
//                   >
//                     <input
//                       className={inputBase}
//                       name="mobile"
//                       placeholder="Enter mobile number"
//                       value={formik.values.mobile}
//                       onChange={formik.handleChange}
//                       onBlur={formik.handleBlur}
//                     />
//                   </FieldWrapper>

//                   {errorText("mobile")}
//                 </div>

//                 {/* Email */}
//                 <div className="col-span-2">
//                   <FieldWrapper
//                     label="Email (Optional)"
//                     icon={<Mail size={18} />}
//                   >
//                     <input
//                       className={inputBase}
//                       name="email"
//                       placeholder="Enter email address"
//                       value={formik.values.email}
//                       onChange={formik.handleChange}
//                       onBlur={formik.handleBlur}
//                     />
//                   </FieldWrapper>

//                   {errorText("email")}
//                 </div>
//               </div>
//             </section>

//             {/* Divider */}
//             <div className="my-3 border-t border-gray-200" />

//             {/* Address Details */}
//             <section className="pt-0">
//               <h2 className="mb-3 text-[22px] font-bold text-black">
//                 Address Details
//               </h2>

//               {/* Address Type */}
//               <div className="relative mb-4 rounded-xl border border-gray-300 px-3 pb-3 pt-4">
//                 <label className="absolute -top-2 left-3 bg-white px-1.5 text-[11px] font-medium text-gray-700">
//                   Address Type *
//                 </label>

//                 <div className="grid grid-cols-3 gap-2">
//                   {[
//                     {
//                       key: "home",
//                       label: "Home",
//                       icon: <Home size={18} />,
//                     },
//                     {
//                       key: "work",
//                       label: "Work",
//                       icon: <Briefcase size={18} />,
//                     },
//                     {
//                       key: "other",
//                       label: "Other",
//                       icon: <MoreHorizontal size={18} />,
//                     },
//                   ].map((item) => (
//                     <button
//                       key={item.key}
//                       type="button"
//                       onClick={() =>
//                         setAddressType(item.key as any)
//                       }
//                       className="flex items-center gap-2 text-sm font-medium text-gray-800"
//                     >
//                       <span
//                         className={`h-5 w-5 rounded-full border ${
//                           addressType === item.key
//                             ? "border-primary-color ring-4 ring-pink-100"
//                             : "border-gray-400"
//                         }`}
//                       />

//                       {item.icon}

//                       <span>{item.label}</span>
//                     </button>
//                   ))}
//                 </div>
//               </div>

//               <div className="grid grid-cols-1 gap-3">
//                 {/* Address */}
//                 <div>
//                   <FieldWrapper
//                     label="Flat, House No., Building Name *"
//                     icon={<Home size={18} />}
//                   >
//                     <input
//                       className={inputBase}
//                       name="address"
//                       placeholder="E.g. 21, Lake View Apartment"
//                       value={formik.values.address}
//                       onChange={formik.handleChange}
//                       onBlur={formik.handleBlur}
//                     />
//                   </FieldWrapper>

//                   {errorText("address")}
//                 </div>

//                 {/* Locality */}
//                 <div>
//                   <FieldWrapper
//                     label="Area, Street, Sector, Village *"
//                     icon={<MapPin size={18} />}
//                   >
//                     <input
//                       className={inputBase}
//                       name="locality"
//                       placeholder="E.g. 5th Cross, Koramangala"
//                       value={formik.values.locality}
//                       onChange={formik.handleChange}
//                       onBlur={formik.handleBlur}
//                     />
//                   </FieldWrapper>

//                   {errorText("locality")}
//                 </div>

//                 {/* Landmark */}
//                 <FieldWrapper
//                   label="Landmark (Optional)"
//                   icon={<Flag size={18} />}
//                 >
//                   <input
//                     className={inputBase}
//                     name="landmark"
//                     placeholder="E.g. Near Forum Mall"
//                     value={formik.values.landmark}
//                     onChange={formik.handleChange}
//                   />
//                 </FieldWrapper>

//                 {/* City / State */}
//                 <div className="grid grid-cols-2 gap-3">
//                   <div>
//                     <FieldWrapper
//                       label="City / Town *"
//                       icon={<Building2 size={18} />}
//                     >
//                       <input
//                         className={inputBase}
//                         name="city"
//                         placeholder="Select city"
//                         value={formik.values.city}
//                         onChange={formik.handleChange}
//                         onBlur={formik.handleBlur}
//                         disabled={autoFilled}
//                       />
//                     </FieldWrapper>

//                     {errorText("city")}
//                   </div>

//                   <div>
//                     <FieldWrapper
//                       label="State *"
//                       icon={<Map size={18} />}
//                     >
//                       <input
//                         className={inputBase}
//                         name="state"
//                         placeholder="Select state"
//                         value={formik.values.state}
//                         onChange={formik.handleChange}
//                         onBlur={formik.handleBlur}
//                         disabled={autoFilled}
//                       />
//                     </FieldWrapper>

//                     {errorText("state")}
//                   </div>

//                   {/* Pincode */}
//                   <div>
//                     <FieldWrapper
//                       label="Pincode *"
//                       icon={<Mail size={18} />}
//                     >
//                       <input
//                         className={inputBase}
//                         name="pinCode"
//                         placeholder="Enter pincode"
//                         value={formik.values.pinCode}
//                         onChange={formik.handleChange}
//                         onBlur={formik.handleBlur}
//                       />
//                     </FieldWrapper>

//                     {errorText("pinCode")}
//                   </div>

//                   {/* Country */}
//                   <FieldWrapper
//                     label="Country *"
//                     icon={<Globe2 size={18} />}
//                   >
//                     <input
//                       className={inputBase}
//                       name="country"
//                       value={formik.values.country}
//                       disabled
//                     />
//                   </FieldWrapper>
//                 </div>

//                 {/* Default Address */}
//                 <label className="mt-1 flex items-start gap-3 rounded-xl border border-gray-300 p-3">
//                   <input
//                     type="radio"
//                     checked={isDefault}
//                     onChange={() => setIsDefault(!isDefault)}
//                     className="mt-1 h-4 w-4 accent-primary-color"
//                   />

//                   <div>
//                     <p className="text-sm font-semibold text-black">
//                       Set as Default Address
//                     </p>

//                     <p className="text-xs text-gray-500">
//                       This address will be used for all future
//                       orders
//                     </p>
//                   </div>
//                 </label>
//               </div>
//             </section>
//           </div>

//           {/* Footer */}
//           <div className="shrink-0 border-t border-gray-200 bg-white p-4">
//             <button
//               type="submit"
//               className="mb-3 h-[48px] w-full rounded-xl bg-primary-color font-semibold text-white shadow-sm transition hover:opacity-90"
//             >
//               Save Address
//             </button>

//             <button
//               type="button"
//               onClick={handleClose}
//               className="h-[48px] w-full rounded-xl border border-primary-color font-semibold text-primary-color transition hover:bg-primary-color/5"
//             >
//               Cancel
//             </button>
//           </div>
//         </form>
//       </div>
//     </Box>
//   );
// };

// export default AddressForm;



// import React, { useEffect, useState } from "react";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import { Box } from "@mui/material";
// import {
//   X,
//   User,
//   Phone,
//   Mail,
//   Home,
//   Briefcase,
//   MoreHorizontal,
//   MapPin,
//   Flag,
//   Building2,
//   Map,
// } from "lucide-react";
// import { useAppDispatch } from "../../../Redux Toolkit/Store";
// import { createOrder } from "../../../Redux Toolkit/Customer/OrderSlice";
// import { Address } from "../../../types/userTypes";

// const ContactSchema = Yup.object().shape({
//   name: Yup.string()
//     .trim()
//     .matches(/^[A-Za-z ]+$/, "Name should contain only letters")
//     .min(3, "Name must be at least 3 characters")
//     .required("Name is required"),

//   mobile: Yup.string()
//     .matches(/^[6-9]\d{9}$/, "Mobile number must be exactly 10 digits")
//     .required("Mobile number is required"),

//   email: Yup.string().email("Invalid email address"),

//   pinCode: Yup.string()
//     .matches(/^\d{6}$/, "Pincode must be exactly 6 digits")
//     .required("Pincode is required"),

//   address: Yup.string()
//     .trim()
//     .min(5, "Address must be at least 5 characters")
//     .required("Address is required"),

//   locality: Yup.string()
//     .trim()
//     .min(3, "Locality must be at least 3 characters")
//     .required("Locality is required"),

//   city: Yup.string()
//     .trim()
//     .matches(/^[A-Za-z ]+$/, "City should contain only letters")
//     .required("City is required"),

//   state: Yup.string()
//     .trim()
//     .matches(/^[A-Za-z ]+$/, "State should contain only letters")
//     .required("State is required"),
// });

// interface AddressFormProp {
//   handleClose: () => void;
//   paymentGateway?: string;
//   mode?: "checkout" | "profile";
//   onAddressSubmit?: (address: Address) => void;
// }

// const inputBase =
//   "w-full h-[46px] rounded-xl border border-gray-300 bg-white px-3 pl-10 text-sm outline-none transition focus:border-primary-color focus:ring-1 focus:ring-primary-color";

// const labelBase =
//   "absolute -top-2 left-3 z-10 bg-white px-1.5 text-[11px] font-medium text-gray-700";

// const FieldWrapper = ({
//   label,
//   icon,
//   children,
// }: {
//   label: string;
//   icon: React.ReactNode;
//   children: React.ReactNode;
// }) => (
//   <div className="relative">
//     <label className={labelBase}>{label}</label>
//     <div className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-600">
//       {icon}
//     </div>
//     {children}
//   </div>
// );

// const AddressForm: React.FC<AddressFormProp> = ({
//   handleClose,
//   paymentGateway = "",
//   mode = "checkout",
//   onAddressSubmit,
// }) => {
//   const dispatch = useAppDispatch();
//   const [autoFilled, setAutoFilled] = useState(false);
//   const [addressType, setAddressType] = useState<"home" | "work" | "other">(
//     "home"
//   );
//   const [isDefault, setIsDefault] = useState(true);

//   const handleCreateOrder = (address: Address) => {
//     dispatch(
//       createOrder({
//         address,
//         jwt: localStorage.getItem("jwt") || "",
//         paymentGateway,
//       })
//     );
//   };

//   const formik = useFormik({
//     initialValues: {
//       name: "",
//       mobile: "",
//       email: "",
//       address: "",
//       locality: "",
//       landmark: "",
//       pinCode: "",
//       city: "",
//       state: "",
//     },
//     validationSchema: ContactSchema,
//     onSubmit: (values) => {
//       const address = {
//         name: values.name,
//         mobile: values.mobile,
//         pinCode: values.pinCode,
//         address: values.address,
//         locality: values.locality,
//         city: values.city,
//         state: values.state,
//       } as Address;

//       if (mode === "checkout") {
//         handleCreateOrder(address);
//       }

//       onAddressSubmit?.(address);
//       handleClose();
//     },
//   });

//   useEffect(() => {
//     const fetchLocation = async () => {
//       const pinCode = formik.values.pinCode;

//       if (pinCode.length === 6) {
//         try {
//           const res = await fetch(
//             `https://api.postalpincode.in/pincode/${pinCode}`
//           );

//           const data = await res.json();

//           if (data[0].Status === "Success") {
//             const postOffice = data[0].PostOffice[0];

//             formik.setFieldValue("city", postOffice.District);
//             formik.setFieldValue("state", postOffice.State);
//             setAutoFilled(true);
//           } else {
//             setAutoFilled(false);
//           }
//         } catch (error) {
//           console.error("Error fetching city/state:", error);
//           setAutoFilled(false);
//         }
//       } else {
//         setAutoFilled(false);
//       }
//     };

//     fetchLocation();
//   }, [formik.values.pinCode]);

//   const errorText = (field: keyof typeof formik.values) =>
//     formik.touched[field] && formik.errors[field] ? (
//       <p className="mt-1 text-[10px] text-red-500">{formik.errors[field]}</p>
//     ) : null;

//   return (
//     <Box sx={{ width: "100%", outline: "none", overflow: "hidden" }}>
//       <div className="mx-auto flex max-h-[88vh] w-full max-w-[430px] flex-col overflow-hidden rounded-3xl bg-white shadow-2xl md:max-w-[620px]">
//         <div className="relative flex h-[60px] shrink-0 items-center justify-center border-b border-gray-200 px-4">
//           <h1 className="text-xl font-bold text-black">Add New Address</h1>

//           <button
//             type="button"
//             onClick={handleClose}
//             className="absolute right-4 text-black"
//           >
//             <X size={22} />
//           </button>
//         </div>

//         <form
//           onSubmit={formik.handleSubmit}
//           className="flex min-h-0 flex-1 flex-col"
//         >
//           <div className="min-h-0 flex-1 overflow-y-auto px-4 py-4">
//             <div className="grid grid-cols-2 gap-3">
//               <div>
//                 <FieldWrapper label="Full Name *" icon={<User size={18} />}>
//                   <input
//                     className={inputBase}
//                     name="name"
//                     placeholder="Enter full name"
//                     value={formik.values.name}
//                     onChange={formik.handleChange}
//                     onBlur={formik.handleBlur}
//                   />
//                 </FieldWrapper>
//                 {errorText("name")}
//               </div>

//               <div>
//                 <FieldWrapper label="Mobile Number *" icon={<Phone size={18} />}>
//                   <input
//                     className={inputBase}
//                     name="mobile"
//                     placeholder="Enter mobile number"
//                     value={formik.values.mobile}
//                     onChange={formik.handleChange}
//                     onBlur={formik.handleBlur}
//                   />
//                 </FieldWrapper>
//                 {errorText("mobile")}
//               </div>

//               <div className="col-span-2">
//                 <FieldWrapper label="Email (Optional)" icon={<Mail size={18} />}>
//                   <input
//                     className={inputBase}
//                     name="email"
//                     placeholder="Enter email address"
//                     value={formik.values.email}
//                     onChange={formik.handleChange}
//                     onBlur={formik.handleBlur}
//                   />
//                 </FieldWrapper>
//                 {errorText("email")}
//               </div>

//               <div className="relative col-span-2 rounded-xl border border-gray-300 px-3 pb-3 pt-4">
//                 <label className="absolute -top-2 left-3 bg-white px-1.5 text-[11px] font-medium text-gray-700">
//                   Address Type *
//                 </label>

//                 <div className="grid grid-cols-3 gap-2">
//                   {[
//                     { key: "home", label: "Home", icon: <Home size={18} /> },
//                     {
//                       key: "work",
//                       label: "Work",
//                       icon: <Briefcase size={18} />,
//                     },
//                     {
//                       key: "other",
//                       label: "Other",
//                       icon: <MoreHorizontal size={18} />,
//                     },
//                   ].map((item) => (
//                     <button
//                       key={item.key}
//                       type="button"
//                       onClick={() => setAddressType(item.key as any)}
//                       className="flex items-center gap-2 text-sm font-medium text-gray-800"
//                     >
//                       <span
//                         className={`h-5 w-5 rounded-full border ${addressType === item.key
//                           ? "border-primary-color ring-4 ring-pink-100"
//                           : "border-gray-400"
//                           }`}
//                       />
//                       {item.icon}
//                       <span>{item.label}</span>
//                     </button>
//                   ))}
//                 </div>
//               </div>

//               <div className="col-span-2">
//                 <FieldWrapper
//                   label="Flat, House No., Building Name *"
//                   icon={<Home size={18} />}
//                 >
//                   <input
//                     className={inputBase}
//                     name="address"
//                     placeholder="E.g. 21, Lake View Apartment"
//                     value={formik.values.address}
//                     onChange={formik.handleChange}
//                     onBlur={formik.handleBlur}
//                   />
//                 </FieldWrapper>
//                 {errorText("address")}
//               </div>

//               <div className="col-span-2">
//                 <FieldWrapper
//                   label="Area, Street, Sector, Village *"
//                   icon={<MapPin size={18} />}
//                 >
//                   <input
//                     className={inputBase}
//                     name="locality"
//                     placeholder="E.g. 5th Cross, Koramangala"
//                     value={formik.values.locality}
//                     onChange={formik.handleChange}
//                     onBlur={formik.handleBlur}
//                   />
//                 </FieldWrapper>
//                 {errorText("locality")}
//               </div>

//               <div className="col-span-2">
//                 <FieldWrapper
//                   label="Landmark (Optional)"
//                   icon={<Flag size={18} />}
//                 >
//                   <input
//                     className={inputBase}
//                     name="landmark"
//                     placeholder="E.g. Near Forum Mall"
//                     value={formik.values.landmark}
//                     onChange={formik.handleChange}
//                   />
//                 </FieldWrapper>
//               </div>

//               <div>
//                 <FieldWrapper label="Pincode *" icon={<Mail size={18} />}>
//                   <input
//                     className={inputBase}
//                     name="pinCode"
//                     placeholder="Enter pincode"
//                     value={formik.values.pinCode}
//                     onChange={formik.handleChange}
//                     onBlur={formik.handleBlur}
//                   />
//                 </FieldWrapper>
//                 {errorText("pinCode")}
//               </div>

//               <div>
//                 <FieldWrapper label="City / Town *" icon={<Building2 size={18} />}>
//                   <input
//                     className={inputBase}
//                     name="city"
//                     placeholder="Select city"
//                     value={formik.values.city}
//                     onChange={formik.handleChange}
//                     onBlur={formik.handleBlur}
//                     disabled={autoFilled}
//                   />
//                 </FieldWrapper>
//                 {errorText("city")}
//               </div>

//               <div>
//                 <FieldWrapper label="State *" icon={<Map size={18} />}>
//                   <input
//                     className={inputBase}
//                     name="state"
//                     placeholder="Select state"
//                     value={formik.values.state}
//                     onChange={formik.handleChange}
//                     onBlur={formik.handleBlur}
//                     disabled={autoFilled}
//                   />
//                 </FieldWrapper>

//                 {errorText("state")}
//               </div>

//               <div className="flex h-[48px] items-center justify-between rounded-xl border border-gray-300 px-4">
//                 <p className="text-sm font-medium text-gray-800">
//                   Make it default
//                 </p>

//                 <button
//                   type="button"
//                   onClick={() => setIsDefault(!isDefault)}
//                   className={`relative h-7 w-12 rounded-full transition ${isDefault ? "bg-primary-color" : "bg-gray-300"
//                     }`}
//                 >
//                   <span
//                     className={`absolute top-1 h-5 w-5 rounded-full bg-white transition ${isDefault ? "right-1" : "left-1"
//                       }`}
//                   />
//                 </button>
//               </div>
//             </div>
//           </div>

//           <div className="shrink-0 border-t border-gray-200 bg-white p-4">
//             <button
//               type="submit"
//               className="mb-3 h-[48px] w-full rounded-xl bg-primary-color font-semibold text-white shadow-sm transition hover:opacity-90"
//             >
//               Save Address
//             </button>

//             <button
//               type="button"
//               onClick={handleClose}
//               className="h-[48px] w-full rounded-xl border border-primary-color font-semibold text-primary-color transition hover:bg-primary-color/5"
//             >
//               Cancel
//             </button>
//           </div>
//         </form>
//       </div>
//     </Box>
//   );
// };

// export default AddressForm;


// import React, { useEffect, useState } from "react";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import { Box } from "@mui/material";
// import {
//   X,
//   User,
//   Phone,
//   Mail,
//   Home,
//   Briefcase,
//   MapPin,
//   Flag,
//   Building2,
//   Map,
// } from "lucide-react";
// import { useAppDispatch } from "../../../Redux Toolkit/Store";
// import { createOrder } from "../../../Redux Toolkit/Customer/OrderSlice";
// import { Address } from "../../../types/userTypes";

// const ContactSchema = Yup.object().shape({
//   name: Yup.string()
//     .trim()
//     .matches(/^[A-Za-z ]+$/, "Name should contain only letters")
//     .min(3, "Name must be at least 3 characters")
//     .required("Name is required"),

//   mobile: Yup.string()
//     .matches(/^[6-9]\d{9}$/, "Mobile number must be exactly 10 digits")
//     .required("Mobile number is required"),

//   email: Yup.string().email("Invalid email address"),

//   pinCode: Yup.string()
//     .matches(/^\d{6}$/, "Pincode must be exactly 6 digits")
//     .required("Pincode is required"),

//   address: Yup.string()
//     .trim()
//     .min(5, "Address must be at least 5 characters")
//     .required("Address is required"),

//   locality: Yup.string()
//     .trim()
//     .min(3, "Locality must be at least 3 characters")
//     .required("Locality is required"),

//   city: Yup.string()
//     .trim()
//     .matches(/^[A-Za-z ]+$/, "City should contain only letters")
//     .required("City is required"),

//   state: Yup.string()
//     .trim()
//     .matches(/^[A-Za-z ]+$/, "State should contain only letters")
//     .required("State is required"),
// });

// interface AddressFormProp {
//   handleClose: () => void;
//   paymentGateway?: string;
//   mode?: "checkout" | "profile";
//   onAddressSubmit?: (address: Address) => void;
// }

// const inputBase =
//   "w-full h-[46px] rounded-xl border border-gray-300 bg-white px-3 pl-10 text-sm outline-none transition focus:border-primary-color focus:ring-1 focus:ring-primary-color";

// const labelBase =
//   "absolute -top-2 left-3 z-10 bg-white px-1.5 text-[11px] font-medium text-gray-700";

// const FieldWrapper = ({
//   label,
//   icon,
//   children,
// }: {
//   label: string;
//   icon: React.ReactNode;
//   children: React.ReactNode;
// }) => (
//   <div className="relative">
//     <label className={labelBase}>{label}</label>
//     <div className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-600">
//       {icon}
//     </div>
//     {children}
//   </div>
// );

// const AddressForm: React.FC<AddressFormProp> = ({
//   handleClose,
//   paymentGateway = "",
//   mode = "checkout",
//   onAddressSubmit,
// }) => {
//   const dispatch = useAppDispatch();
//   const [autoFilled, setAutoFilled] = useState(false);
//   const [addressType, setAddressType] = useState<"home" | "work">("home");
//   const [isDefault, setIsDefault] = useState(false);

//   const handleCreateOrder = (address: Address) => {
//     dispatch(
//       createOrder({
//         address,
//         jwt: localStorage.getItem("jwt") || "",
//         paymentGateway,
//       })
//     );
//   };

//   const formik = useFormik({
//     initialValues: {
//       name: "",
//       mobile: "",
//       email: "",
//       address: "",
//       locality: "",
//       landmark: "",
//       pinCode: "",
//       city: "",
//       state: "",
//     },
//     validationSchema: ContactSchema,
//     onSubmit: (values) => {
//       const address = {
//         name: values.name,
//         mobile: values.mobile,
//         pinCode: values.pinCode,
//         address: values.address,
//         locality: values.locality,
//         city: values.city,
//         state: values.state,
//       } as Address;

//       if (mode === "checkout") {
//         handleCreateOrder(address);
//       }

//       onAddressSubmit?.(address);
//       handleClose();
//     },
//   });

//   useEffect(() => {
//     const fetchLocation = async () => {
//       const pinCode = formik.values.pinCode;

//       if (pinCode.length === 6) {
//         try {
//           const res = await fetch(
//             `https://api.postalpincode.in/pincode/${pinCode}`
//           );

//           const data = await res.json();

//           if (data[0].Status === "Success") {
//             const postOffice = data[0].PostOffice[0];

//             formik.setFieldValue("city", postOffice.District);
//             formik.setFieldValue("state", postOffice.State);
//             setAutoFilled(true);
//           } else {
//             setAutoFilled(false);
//           }
//         } catch (error) {
//           console.error("Error fetching city/state:", error);
//           setAutoFilled(false);
//         }
//       } else {
//         setAutoFilled(false);
//       }
//     };

//     fetchLocation();
//   }, [formik.values.pinCode]);

//   const errorText = (field: keyof typeof formik.values) =>
//     formik.touched[field] && formik.errors[field] ? (
//       <p className="mt-1 text-[10px] text-red-500">{formik.errors[field]}</p>
//     ) : null;

//   return (
//     <Box sx={{ width: "100%", outline: "none", overflow: "hidden" }}>
//       <div className="mx-auto mt-4 flex w-full max-w-[430px] flex-col overflow-hidden rounded-3xl bg-white p-4 shadow-2xl md:mt-6 md:max-w-[620px] md:p-5">
//         <div className="relative flex h-[58px] shrink-0 items-center justify-center border-b border-gray-200 px-4">
//           <h1 className="text-xl font-bold text-black">Add New Address</h1>

//           <button
//             type="button"
//             onClick={handleClose}
//             className="absolute right-4 text-black"
//           >
//             <X size={22} />
//           </button>
//         </div>

//         <form onSubmit={formik.handleSubmit} className="pt-5 px-1 pb-2">
//           <div className="grid grid-cols-2 gap-3">
//             <div>
//               <FieldWrapper label="Full Name *" icon={<User size={18} />}>
//                 <input
//                   className={inputBase}
//                   name="name"
//                   placeholder="Enter full name"
//                   value={formik.values.name}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                 />
//               </FieldWrapper>
//               {errorText("name")}
//             </div>

//             <div>
//               <FieldWrapper label="Mobile Number *" icon={<Phone size={18} />}>
//                 <input
//                   className={inputBase}
//                   name="mobile"
//                   placeholder="Enter mobile number"
//                   value={formik.values.mobile}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                 />
//               </FieldWrapper>
//               {errorText("mobile")}
//             </div>

//             <div className="col-span-2">
//               <FieldWrapper label="Email (Optional)" icon={<Mail size={18} />}>
//                 <input
//                   className={inputBase}
//                   name="email"
//                   placeholder="Enter email address"
//                   value={formik.values.email}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                 />
//               </FieldWrapper>
//               {errorText("email")}
//             </div>

//             <div className="relative rounded-xl border border-gray-300 px-3 pb-3 pt-4">
//               <label className="absolute -top-2 left-3 bg-white px-1.5 text-[11px] font-medium text-gray-700">
//                 Address Type *
//               </label>

//               <div className="grid grid-cols-2 gap-2">
//                 {[
//                   { key: "home", label: "Home", icon: <Home size={18} /> },
//                   { key: "work", label: "Work", icon: <Briefcase size={18} /> },
//                 ].map((item) => (
//                   <button
//                     key={item.key}
//                     type="button"
//                     onClick={() => setAddressType(item.key as "home" | "work")}
//                     className="flex items-center gap-2 text-sm font-medium text-gray-800"
//                   >
//                     <span
//                       className={`h-5 w-5 rounded-full border ${addressType === item.key
//                           ? "border-primary-color ring-4 ring-pink-100"
//                           : "border-gray-400"
//                         }`}
//                     />
//                     {item.icon}
//                     <span>{item.label}</span>
//                   </button>
//                 ))}
//               </div>
//             </div>

//             <div>
//               <FieldWrapper label="Pincode *" icon={<Mail size={18} />}>
//                 <input
//                   className={inputBase}
//                   name="pinCode"
//                   placeholder="Enter pincode"
//                   value={formik.values.pinCode}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                 />
//               </FieldWrapper>
//               {errorText("pinCode")}
//             </div>

//             <div className="col-span-2">
//               <FieldWrapper
//                 label="Flat, House No., Building Name *"
//                 icon={<Home size={18} />}
//               >
//                 <input
//                   className={inputBase}
//                   name="address"
//                   placeholder="E.g. 21, Lake View Apartment"
//                   value={formik.values.address}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                 />
//               </FieldWrapper>
//               {errorText("address")}
//             </div>

//             <div className="col-span-2">
//               <FieldWrapper
//                 label="Area, Street, Sector, Village *"
//                 icon={<MapPin size={18} />}
//               >
//                 <input
//                   className={inputBase}
//                   name="locality"
//                   placeholder="E.g. 5th Cross, Koramangala"
//                   value={formik.values.locality}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                 />
//               </FieldWrapper>
//               {errorText("locality")}
//             </div>

//             <div className="col-span-2">
//               <FieldWrapper
//                 label="Landmark (Optional)"
//                 icon={<Flag size={18} />}
//               >
//                 <input
//                   className={inputBase}
//                   name="landmark"
//                   placeholder="E.g. Near Forum Mall"
//                   value={formik.values.landmark}
//                   onChange={formik.handleChange}
//                 />
//               </FieldWrapper>
//             </div>

//             <div>
//               <FieldWrapper label="City / Town *" icon={<Building2 size={18} />}>
//                 <input
//                   className={inputBase}
//                   name="city"
//                   placeholder="Select city"
//                   value={formik.values.city}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   disabled={autoFilled}
//                 />
//               </FieldWrapper>
//               {errorText("city")}
//             </div>

//             <div>
//               <FieldWrapper label="State *" icon={<Map size={18} />}>
//                 <input
//                   className={inputBase}
//                   name="state"
//                   placeholder="Select state"
//                   value={formik.values.state}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   disabled={autoFilled}
//                 />
//               </FieldWrapper>
//               {errorText("state")}
//             </div>

//             <label className="col-span-2 mt-1 flex items-center gap-3 px-1 text-sm font-medium text-gray-800">
//               <input
//                 type="checkbox"
//                 checked={isDefault}
//                 onChange={() => setIsDefault(!isDefault)}
//                 className="h-4 w-4 rounded accent-primary-color"
//               />
//               Make it default
//             </label>
//           </div>

//           <div className="mt-4 border-t border-gray-200 pt-4">
//             <button
//               type="submit"
//               className="mb-3 h-[48px] w-full rounded-xl bg-primary-color font-semibold text-white shadow-sm transition hover:opacity-90"
//             >
//               Save Address
//             </button>

//             <button
//               type="button"
//               onClick={handleClose}
//               className="h-[48px] w-full rounded-xl border border-primary-color font-semibold text-primary-color transition hover:bg-primary-color/5"
//             >
//               Cancel
//             </button>
//           </div>
//         </form>
//       </div>
//     </Box>
//   );
// };

// export default AddressForm;


import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Box } from "@mui/material";
import {
  X,
  User,
  Phone,
  Mail,
  Home,
  Briefcase,
  MapPin,
  Flag,
  Building2,
  Map,
} from "lucide-react";
import { useAppDispatch } from "../../../Redux Toolkit/Store";
import { createOrder } from "../../../Redux Toolkit/Customer/OrderSlice";
import { Address } from "../../../types/userTypes";

const ContactSchema = Yup.object().shape({
  name: Yup.string()
    .trim()
    .matches(/^[A-Za-z ]+$/, "Name should contain only letters")
    .min(3, "Name must be at least 3 characters")
    .required("Name is required"),

  mobile: Yup.string()
    .matches(/^[6-9]\d{9}$/, "Mobile number must be exactly 10 digits")
    .required("Mobile number is required"),

  email: Yup.string().email("Invalid email address"),

  pinCode: Yup.string()
    .matches(/^\d{6}$/, "Pincode must be exactly 6 digits")
    .required("Pincode is required"),

  address: Yup.string()
    .trim()
    .min(5, "Address must be at least 5 characters")
    .required("Address is required"),

  locality: Yup.string()
    .trim()
    .min(3, "Locality must be at least 3 characters")
    .required("Locality is required"),

  city: Yup.string()
    .trim()
    .matches(/^[A-Za-z ]+$/, "City should contain only letters")
    .required("City is required"),

  state: Yup.string()
    .trim()
    .matches(/^[A-Za-z ]+$/, "State should contain only letters")
    .required("State is required"),
});

interface AddressFormProp {
  handleClose: () => void;
  paymentGateway?: string;
  mode?: "checkout" | "profile";
  onAddressSubmit?: (address: Address) => void;
  initialAddress?: Address | null;
}

const inputBase =
  "w-full h-[46px] rounded-xl border border-gray-300 bg-white disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed px-3 pl-10 text-sm outline-none transition focus:border-primary-color focus:ring-1 focus:ring-primary-color";

const labelBase =
  "absolute -top-2 left-3 z-10 bg-white px-1.5 text-[11px] font-medium text-gray-700";

const FieldWrapper = ({
  label,
  icon,
  children,
}: {
  label: string;
  icon: React.ReactNode;
  children: React.ReactNode;
}) => (
  <div className="relative">
    <label className={labelBase}>{label}</label>

    <div className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-600">
      {icon}
    </div>

    {children}
  </div>
);

const AddressForm: React.FC<AddressFormProp> = ({
  handleClose,
  paymentGateway = "",
  mode = "checkout",
  onAddressSubmit,
  initialAddress,
}) => {
  const dispatch = useAppDispatch();
  const [autoFilled, setAutoFilled] = useState(false);
  const [addressType, setAddressType] = useState<"home" | "work">("home");
  const [isDefault, setIsDefault] = useState(false);

  useEffect(() => {
    if (initialAddress?.addressType?.toLowerCase() === "work") {
      setAddressType("work");
    } else {
      setAddressType("home");
    }

    setIsDefault(Boolean(initialAddress?.defaultAddress));
  }, [initialAddress]);

  const handleCreateOrder = (address: Address) => {
    dispatch(
      createOrder({
        address,
        jwt: localStorage.getItem("jwt") || "",
        paymentGateway,
      })
    );
  };

  const formik = useFormik({
    initialValues: {
      name: initialAddress?.name || "",
      mobile: initialAddress?.mobile || "",
      email: initialAddress?.email || "",
      address: initialAddress?.address || "",
      locality: initialAddress?.locality || "",
      landmark: initialAddress?.landmark || "",
      pinCode: initialAddress?.pinCode || "",
      city: initialAddress?.city || "",
      state: initialAddress?.state || "",
    },
    enableReinitialize: true,
    validationSchema: ContactSchema,
    onSubmit: (values) => {
      const address = {
        ...initialAddress,
        name: values.name.trim(),
        mobile: values.mobile.trim(),
        email: values.email.trim(),
        addressType: addressType === "home" ? "Home" : "Work",
        pinCode: values.pinCode.trim(),
        address: values.address.trim(),
        locality: values.locality.trim(),
        landmark: values.landmark.trim(),
        city: values.city.trim(),
        state: values.state.trim(),
        defaultAddress: isDefault,
      } as Address;

      if (mode === "checkout") {
        handleCreateOrder(address);
        handleClose();
        return;
      }

      onAddressSubmit?.(address);
    },
  });

  useEffect(() => {
    const fetchLocation = async () => {
      const pinCode = formik.values.pinCode;

      if (pinCode.length === 6 && pinCode !== initialAddress?.pinCode) {
        try {
          const res = await fetch(
            `https://api.postalpincode.in/pincode/${pinCode}`
          );

          const data = await res.json();

          if (data[0].Status === "Success") {
            const postOffice = data[0].PostOffice[0];

            formik.setFieldValue("city", postOffice.District);
            formik.setFieldValue("state", postOffice.State);
            setAutoFilled(true);
          } else if (pinCode.length !== 6) {
            setAutoFilled(false);
          }
        } catch (error) {
          console.error("Error fetching city/state:", error);
          setAutoFilled(false);
        }
      } else {
        setAutoFilled(false);
      }
    };

    fetchLocation();
  }, [formik.values.pinCode]);

  const errorText = (field: keyof typeof formik.values) =>
    formik.touched[field] && formik.errors[field] ? (
      <p className="mt-1 text-[10px] text-red-500">{formik.errors[field]}</p>
    ) : null;

  return (
    <Box sx={{ width: "100%", outline: "none", overflow: "hidden" }}>
      <div className="mx-auto mt-4 flex w-full max-w-[430px] flex-col overflow-hidden rounded-3xl bg-white p-4 shadow-2xl md:mt-6 md:max-w-[620px] md:p-5">
        <div className="relative flex h-[58px] shrink-0 items-center justify-center border-b border-gray-200 px-4">
          <h1 className="text-xl font-bold text-black">
            {initialAddress ? "Update Address" : "Add New Address"}
          </h1>

          <button
            type="button"
            onClick={handleClose}
            className="absolute right-4 text-black"
          >
            <X size={22} />
          </button>
        </div>

        <form onSubmit={formik.handleSubmit} className="px-1 pb-2 pt-5">
          <div className="grid grid-cols-2 gap-3">
            <div>
              <FieldWrapper label="Full Name *" icon={<User size={18} />}>
                <input
                  className={inputBase}
                  name="name"
                  placeholder="Enter full name"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </FieldWrapper>
              {errorText("name")}
            </div>

            <div>
              <FieldWrapper label="Mobile Number *" icon={<Phone size={18} />}>
                <input
                  className={inputBase}
                  name="mobile"
                  placeholder="Enter mobile number"
                  value={formik.values.mobile}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </FieldWrapper>
              {errorText("mobile")}
            </div>

            <div className="col-span-2">
              <FieldWrapper label="Email (Optional)" icon={<Mail size={18} />}>
                <input
                  className={inputBase}
                  name="email"
                  placeholder="Enter email address"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </FieldWrapper>
              {errorText("email")}
            </div>

            <div className="relative rounded-xl border border-gray-300 px-3 pb-3 pt-4">
              <label className="absolute -top-2 left-3 bg-white px-1.5 text-[11px] font-medium text-gray-700">
                Address Type *
              </label>

              <div className="grid grid-cols-2 gap-2">
                {[
                  { key: "home", label: "Home", icon: <Home size={18} /> },
                  { key: "work", label: "Work", icon: <Briefcase size={18} /> },
                ].map((item) => (
                  <button
                    key={item.key}
                    type="button"
                    onClick={() => setAddressType(item.key as "home" | "work")}
                    className="flex items-center gap-2 text-sm font-medium text-gray-800"
                  >
                    <span
                      className={`flex h-5 w-5 items-center justify-center rounded-full border ${addressType === item.key
                          ? "border-primary-color"
                          : "border-gray-400"
                        }`}
                    >
                      {addressType === item.key && (
                        <span className="h-3 w-3 rounded-full bg-primary-color" />
                      )}
                    </span>
                    {item.icon}
                    <span>{item.label}</span>
                  </button>
                ))}
              </div>
            </div>

            <div>
              <FieldWrapper label="Pincode *" icon={<Mail size={18} />}>
                <input
                  className={inputBase}
                  name="pinCode"
                  placeholder="Enter pincode"
                  value={formik.values.pinCode}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  disabled={Boolean(initialAddress)}
                />
              </FieldWrapper>
              {errorText("pinCode")}
            </div>

            <div className="col-span-2">
              <FieldWrapper
                label="Flat, House No., Building Name *"
                icon={<Home size={18} />}
              >
                <input
                  className={inputBase}
                  name="address"
                  placeholder="E.g. 21, Lake View Apartment"
                  value={formik.values.address}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </FieldWrapper>
              {errorText("address")}
            </div>

            <div className="col-span-2">
              <FieldWrapper
                label="Area, Street, Sector, Village *"
                icon={<MapPin size={18} />}
              >
                <input
                  className={inputBase}
                  name="locality"
                  placeholder="E.g. 5th Cross, Koramangala"
                  value={formik.values.locality}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </FieldWrapper>
              {errorText("locality")}
            </div>

            <div className="col-span-2">
              <FieldWrapper
                label="Landmark (Optional)"
                icon={<Flag size={18} />}
              >
                <input
                  className={inputBase}
                  name="landmark"
                  placeholder="E.g. Near Forum Mall"
                  value={formik.values.landmark}
                  onChange={formik.handleChange}
                />
              </FieldWrapper>
            </div>

            <div>
              <FieldWrapper
                label="City / Town *"
                icon={<Building2 size={18} />}
              >
                <input
                  className={inputBase}
                  name="city"
                  placeholder="Select city"
                  value={formik.values.city}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  disabled={Boolean(initialAddress) || autoFilled}
                />
              </FieldWrapper>
              {errorText("city")}
            </div>

            <div>
              <FieldWrapper label="State *" icon={<Map size={18} />}>
                <input
                  className={inputBase}
                  name="state"
                  placeholder="Select state"
                  value={formik.values.state}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  disabled={Boolean(initialAddress) || autoFilled}
                />
              </FieldWrapper>
              {errorText("state")}
            </div>

            <label className="col-span-2 mt-1 flex items-center gap-3 px-1 text-sm font-medium text-gray-800">
              <input
                type="checkbox"
                checked={isDefault}
                onChange={() => setIsDefault(!isDefault)}
                className="h-4 w-4 rounded accent-primary-color"
              />
              Make it default
            </label>
          </div>

          <div className="mt-4 border-t border-gray-200 pt-4">
            <button
              type="submit"
              className="mb-3 h-[48px] w-full rounded-xl bg-primary-color font-semibold text-white shadow-sm transition hover:opacity-90"
            >
              {initialAddress ? "Update Address" : "Save Address"}
            </button>

            <button
              type="button"
              onClick={handleClose}
              className="h-[48px] w-full rounded-xl border border-primary-color font-semibold text-primary-color transition hover:bg-primary-color/5"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </Box>
  );
};

export default AddressForm;